import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

import { Button } from 'components/Button';
import { Headline } from 'components/Headline';
import { Image } from 'components/Image';

const Container = styled.div`
  display: flex;
  align-items: center;
  gap: 2.4rem;
`;

const DragButton = styled(Button)``;

const Img = styled(Image)``;

const Title = styled(Headline)`
  width: 24rem;
`;

const TitleCode = styled(Headline)``;

const FlexContainer = styled.div`
  display: flex;
  align-items: center;
  width: 24rem;

  gap: 0.5rem;
`;

const Actions = styled.div`
  justify-self: flex-end;
  display: flex;
`;

const ActionButton = styled(Button)`
  padding: 1.2rem;

  color: ${pickColor('grayDark')};

  border-right: 0.1rem solid ${pickColor('whiteDark')};
`;

const ImageContainer = styled.div`
  flex-basis: 17rem;
  display: flex;
  align-items: center;
`;

const InactiveLayer = styled.div`
  position: absolute;

  top: 50%;
  left: 50%;

  transform: translate(-50%, -50%);
`;

const OutOfStock = styled.div`
  position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
`;

const OnlyPrice = styled.div`
  position: absolute;
  top: 0;
  left: 0;
`;

export {
  ActionButton,
  Actions,
  Container,
  DragButton,
  FlexContainer,
  ImageContainer,
  Img,
  InactiveLayer,
  OnlyPrice,
  OutOfStock,
  Title,
  TitleCode,
};
